import Vue from 'vue'
import Vuex from 'vuex'
import VueResource from 'vue-resource'

import UAParser from 'ua-parser-js'

Vue.use(Vuex)
Vue.use(VueResource)

export default class {
  constructor () {
    this.state = {
      isABCSupported: false,
      account: null,
      autoOpen: null,
      availableTrees: null,
      cta: null,
      hideCtaDelay: null,
      isOpen: false,
      needCta: true,
      showCtaDelay: null,
      state: 'hidden',
      title: null,
      trees: null,
      ua: null
    }
    this.getters = {
      account (state) {
        return state.account
      },
      autoOpen (state) {
        return state.autoOpen
      },
      availableTrees (state) {
        return state.availableTrees
      },
      cta (state) {
        return state.cta
      },
      hideCtaDelay (state) {
        return state.hideCtaDelay
      },
      isABCSupported (state) {
        return state.isABCSupported
      },
      isOpen (state) {
        return state.isOpen
      },
      needCta (state) {
        return state.needCta
      },
      showCtaDelay (state) {
        return state.showCtaDelay
      },
      state (state) {
        return state.state
      },
      title (state) {
        return state.title
      },
      trees (state) {
        return state.trees
      }
    }
    this.mutations = {
      initial (state, params) {
        state.account = params.account
        state.hideCtaDelay = 10
        state.showCtaDelay = 5
        state.autoOpen = 5

        const MOBILE_DEVICES = ['mobile', 'tablet', 'wearable', 'embedded']
        const parser = new UAParser()
        this.ua = parser.getResult()
        const model = this.ua.device.model || 'PC'
        const isMobile = MOBILE_DEVICES.indexOf(this.ua.device.type) > -1

        let windowUrl
        if (process.env.VUE_APP_WINDOW_URL === undefined) {
          windowUrl = window.location.href
        } else {
          windowUrl = process.env.VUE_APP_WINDOW_URL
        }
        state.windowUrl = windowUrl
        state.ua = {
          browser: this.ua.browser.name,
          model: model,
          device: `${model}/${this.ua.os.name}`,
          language: window.navigator.language,
          isMobile: isMobile
        }

        state.isOpen = params.is_open
        if ('title' in params) {
          state.title = params.title
        }
        if ('trees' in params) {
          state.trees = params.trees
        }
      },
      setIsABCSupported (state, value) {
        state.isABCSupported = value
      },
      setAvailableTrees (state, data) {
        state.availableTrees = data
      },
      setNeedCta (state, value) {
        state.needCta = value
      },
      setState (state, value) {
        state.state = value
      }
    }
    this.actions = {
      initAvailableTrees: ({ commit, dispatch, getters }, data) => {
        return new Promise((resolve, reject) => {
          const isAvailable = (tree) => {
            return new Promise((resolve, reject) => {
              if (tree.action !== 'Widget') {
                resolve(false)
              }
              if (tree.target.indexOf('whatsapp') > -1 &&
                  data.$settings.ua.isMobile === false) {
                resolve(false)
              } else if (tree.target.indexOf('bcrw.apple') > -1 &&
                  getters.isABCSupported === false) {
                resolve(false)
              } else if (tree.target.indexOf('businessmessages.google.com') > -1 &&
                  data.$settings.ua.device.indexOf('Android') === -1) {
                resolve(false)
              } else if (tree.target.indexOf('data-gb-service="zenbot"') > -1) {
                const newNode = document.createElement('div')
                newNode.innerHTML = tree.target
                const skills = newNode.querySelector('button').getAttribute(
                  'data-gb-agent-skills').split(',')
                let agentsOnline = false
                let y = 0
                const loopSkills = (arr) => {
                  appendSkill(arr[y], () => {
                    // set x to next item
                    y++

                    // any more items in array? continue loop
                    if (y < arr.length) {
                      loopSkills(arr)
                    } else {
                      // console.log('FINAL AGENT ONLINE', agentsOnline)
                      resolve(agentsOnline)
                    }
                  })
                }

                const appendSkill = (skill, callback) => {
                  Vue.http.get(`https://gbagent.greenbureau.com/api/guests/load/${skill}/`)
                    .then((response) => {
                      // console.log('AGENTS ONLINE', response)
                      if (response.body === 'online') {
                        agentsOnline = true
                      }
                      if (callback !== undefined) {
                        callback()
                      }
                    })
                }

                loopSkills(skills)
              } else {
                resolve(true)
              }
            })
          }
          const trees = []
          let x = 0

          const loopTrees = (arr) => {
            appendTree(arr[x], () => {
              // set x to next item
              x++

              // any more items in array? continue loop
              if (x < arr.length) {
                loopTrees(arr)
              } else {
                commit('setAvailableTrees', trees)
                // console.log('FINAL', trees)
                resolve(true)
              }
            })
          }

          const appendTree = (item, callback) => {
            isAvailable(item).then(availability => {
              if (availability === true) {
                if (item.target.indexOf('apple-business-chat') > -1) {
                  const group = data.group
                  item.target = item.target.replace(':group-id:', group)
                }
                trees.push(item)
              }
              // console.log('AFTER AVAIL')
            }).then(() => {
              if (callback !== undefined) {
                // console.log('BEFORE CALLBACK')
                callback()
              }
            })
          }
          loopTrees(getters.trees)
        })
      },
      log ({ commit, state }, action) {
        const data = {
          kind: action.eventName,
          caller: state.customData['gb-caller'],
          data: JSON.stringify({
            id: action.node.id,
            guid: state.cookie,
            os: {
              name: this.ua.os.name,
              version: this.ua.os.version
            },
            browser: {
              name: this.ua.browser.name,
              version: this.ua.browser.version
            },
            device: {
              model: this.ua.device.model,
              type: this.ua.device.type,
              vendor: this.ua.device.vendor
            }
          })
        }
        console.log('>>>', data)
        // const url = 'log/'
        // return new Promise((resolve, reject) => {
        //   Vue.http.post(url, data).then(response => {
        //     resolve(response)
        //   }, error => {
        //     reject(error)
        //   })
        // })
      }
    }
  }
}
